import React from 'react';
import { businessData } from '../mock';

export const AvisoLegal = () => (
  <div className="max-w-4xl mx-auto px-4 py-12">
    <h1 className="text-3xl font-bold mb-8">Aviso Legal</h1>
    
    <div className="prose prose-lg max-w-none space-y-6">
      <section>
        <h2 className="text-xl font-semibold mb-4">1. Identificación del prestador de servicios</h2>
        <p>
          En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, 
          se informa que el presente sitio web es titularidad de:
        </p>
        <ul className="ml-6 mt-4 space-y-2">
          <li><strong>Denominación social:</strong> {businessData.companyName}</li>
          <li><strong>CIF:</strong> {businessData.cif}</li>
          <li><strong>Domicilio social:</strong> {businessData.address}</li>
          <li><strong>Teléfono:</strong> {businessData.phone}</li>
          <li><strong>Email:</strong> {businessData.email}</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">2. Objeto y ámbito de aplicación</h2>
        <p>
          El presente aviso legal regula el acceso, navegación y uso del sitio web, así como las responsabilidades derivadas 
          de la utilización de sus contenidos. La empresa se dedica a la intermediación en servicios de alquiler de viviendas 
          bajo modalidad de prepago.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">3. Condiciones de acceso y uso</h2>
        <p>
          El acceso a este sitio web es libre y gratuito. Su utilización atribuye la condición de usuario e implica 
          la aceptación plena de las presentes condiciones. El usuario se compromete a hacer un uso adecuado de los contenidos 
          y servicios ofrecidos y a no emplearlos para actividades ilícitas.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">4. Responsabilidad</h2>
        <p>
          La empresa no se responsabiliza de los daños y perjuicios que pudieran derivarse del uso inadecuado del sitio web. 
          Asimismo, no garantiza la ausencia de errores en el acceso al sitio web, en su contenido, ni que el mismo se encuentre 
          actualizado, aunque desarrollará sus mejores esfuerzos para evitarlos, subsanarlos o actualizarlos.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">5. Propiedad intelectual</h2>
        <p>
          Todos los contenidos del sitio web (textos, imágenes, sonidos, audio, vídeo, software, tecnologías, diseños, gráficos, 
          etc.) están protegidos por derechos de propiedad intelectual e industrial. Queda prohibida su reproducción, distribución, 
          comunicación pública, transformación o cualquier otra actividad que se pueda realizar con los contenidos sin autorización.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">6. Legislación aplicable</h2>
        <p>
          Las presentes condiciones se rigen por la legislación española. Para cualquier controversia será competente 
          la jurisdicción de los Juzgados y Tribunales de Madrid.
        </p>
      </section>
    </div>
  </div>
);

export const PoliticaPrivacidad = () => (
  <div className="max-w-4xl mx-auto px-4 py-12">
    <h1 className="text-3xl font-bold mb-8">Política de Privacidad</h1>
    
    <div className="prose prose-lg max-w-none space-y-6">
      <section>
        <h2 className="text-xl font-semibold mb-4">1. Responsable del tratamiento</h2>
        <p>
          <strong>{businessData.companyName}</strong>, con CIF {businessData.cif} y domicilio en {businessData.address}, 
          es el responsable del tratamiento de los datos personales del Usuario y le informa que estos datos serán tratados 
          de conformidad con lo dispuesto en el Reglamento (UE) 2016/679 de 27 de abril de 2016 (GDPR).
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">2. Finalidad del tratamiento de datos</h2>
        <p>Los datos personales que nos proporcione serán utilizados para:</p>
        <ul className="ml-6 mt-4 space-y-2">
          <li>Gestionar y responder a sus consultas a través del formulario de contacto</li>
          <li>Proporcionarle información sobre nuestros servicios de intermediación inmobiliaria</li>
          <li>Establecer comunicaciones comerciales relacionadas con nuestros servicios</li>
          <li>Cumplir con las obligaciones legales aplicables</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">3. Legitimación</h2>
        <p>
          La base legal para el tratamiento de sus datos es el consentimiento del interesado al completar el formulario 
          de contacto, así como el interés legítimo de la empresa para el desarrollo de su actividad comercial.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">4. Conservación de datos</h2>
        <p>
          Los datos se conservarán mientras se mantenga la relación comercial o durante el tiempo necesario para cumplir 
          con las obligaciones legales y responder a las posibles responsabilidades que se pudieran derivar.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">5. Destinatarios</h2>
        <p>
          Los datos no se comunicarán a terceros, salvo obligación legal. Pueden ser tratados por proveedores de servicios 
          tecnológicos que actúan como encargados de tratamiento bajo las debidas garantías de confidencialidad.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">6. Derechos del Usuario</h2>
        <p>Usted tiene derecho a:</p>
        <ul className="ml-6 mt-4 space-y-2">
          <li>Acceder a sus datos personales</li>
          <li>Rectificar datos inexactos</li>
          <li>Solicitar la supresión de sus datos</li>
          <li>Solicitar la limitación del tratamiento</li>
          <li>Oponerse al tratamiento</li>
          <li>Solicitar la portabilidad de los datos</li>
        </ul>
        <p className="mt-4">
          Para ejercer estos derechos puede dirigirse a <strong>{businessData.email}</strong>. 
          También tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos.
        </p>
      </section>
    </div>
  </div>
);

export const TerminosCondiciones = () => (
  <div className="max-w-4xl mx-auto px-4 py-12">
    <h1 className="text-3xl font-bold mb-8">Términos y Condiciones</h1>
    
    <div className="prose prose-lg max-w-none space-y-6">
      <section>
        <h2 className="text-xl font-semibold mb-4">1. Objeto del servicio</h2>
        <p>
          {businessData.companyName} actúa como intermediario entre propietarios de inmuebles e inquilinos interesados 
          en contratos de alquiler bajo modalidad de pago anticipado por períodos de 24 meses.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">2. Servicios ofrecidos</h2>
        <ul className="ml-6 mt-4 space-y-2">
          <li>Búsqueda y selección de inquilinos solventes para propietarios</li>
          <li>Búsqueda de viviendas con descuento para inquilinos con liquidez</li>
          <li>Asesoramiento legal en la redacción de contratos</li>
          <li>Mediación entre las partes durante el proceso</li>
          <li>Seguimiento post-contrato en caso de incidencias</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">3. Comisiones y pagos</h2>
        <p>
          Nuestra comisión se devengará únicamente cuando se produzca la firma efectiva del contrato de arrendamiento 
          entre las partes. No se cobrarán cantidades por consultas, búsquedas o procesos que no concluyan en firma de contrato.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">4. Obligaciones de las partes</h2>
        <h3 className="text-lg font-medium mt-6 mb-3">Propietarios:</h3>
        <ul className="ml-6 space-y-1">
          <li>Proporcionar documentación veraz sobre la propiedad</li>
          <li>Garantizar el estado de habitabilidad del inmueble</li>
          <li>Cumplir con las condiciones pactadas en el contrato</li>
        </ul>
        
        <h3 className="text-lg font-medium mt-6 mb-3">Inquilinos:</h3>
        <ul className="ml-6 space-y-1">
          <li>Acreditar solvencia económica suficiente</li>
          <li>Efectuar el pago anticipado según lo acordado</li>
          <li>Mantener el inmueble en buenas condiciones</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">5. Resolución de conflictos</h2>
        <p>
          En caso de controversias entre las partes, {businessData.companyName} ofrecerá sus servicios de mediación. 
          Si no fuera posible alcanzar un acuerdo, las partes podrán acudir a los tribunales competentes.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">6. Limitación de responsabilidad</h2>
        <p>
          {businessData.companyName} actúa exclusivamente como intermediario y no asume responsabilidades derivadas 
          del cumplimiento o incumplimiento de las obligaciones contractuales entre propietarios e inquilinos.
        </p>
      </section>
    </div>
  </div>
);

export const PoliticaCookies = () => (
  <div className="max-w-4xl mx-auto px-4 py-12">
    <h1 className="text-3xl font-bold mb-8">Política de Cookies</h1>
    
    <div className="prose prose-lg max-w-none space-y-6">
      <section>
        <h2 className="text-xl font-semibold mb-4">¿Qué son las cookies?</h2>
        <p>
          Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita nuestro sitio web. 
          Nos ayudan a mejorar la funcionalidad del sitio y su experiencia de usuario.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">Tipos de cookies que utilizamos</h2>
        
        <h3 className="text-lg font-medium mt-6 mb-3">Cookies necesarias</h3>
        <p>
          Son esenciales para que el sitio web funcione correctamente. Incluyen cookies de sesión, configuración 
          de idioma y otras funcionalidades básicas. No pueden ser desactivadas.
        </p>

        <h3 className="text-lg font-medium mt-6 mb-3">Cookies de análisis</h3>
        <p>
          Nos permiten analizar cómo los usuarios utilizan nuestro sitio web para mejorar su funcionamiento y 
          optimizar la experiencia de usuario. Utilizamos Google Analytics para este propósito.
        </p>

        <h3 className="text-lg font-medium mt-6 mb-3">Cookies de marketing</h3>
        <p>
          Se utilizan para mostrar anuncios personalizados y medir la efectividad de nuestras campañas publicitarias. 
          Solo se activan con su consentimiento explícito.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">Gestión de cookies</h2>
        <p>
          Puede gestionar sus preferencias de cookies a través del banner que aparece en su primera visita al sitio web. 
          También puede configurar su navegador para rechazar todas las cookies, aunque esto podría afectar 
          la funcionalidad del sitio.
        </p>
        
        <p className="mt-4">
          Para más información sobre cómo gestionar cookies en los principales navegadores:
        </p>
        <ul className="ml-6 mt-4 space-y-2">
          <li><a href="https://support.google.com/chrome/answer/95647" className="text-green-600 hover:underline" target="_blank" rel="noopener">Chrome</a></li>
          <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" className="text-green-600 hover:underline" target="_blank" rel="noopener">Firefox</a></li>
          <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" className="text-green-600 hover:underline" target="_blank" rel="noopener">Safari</a></li>
          <li><a href="https://support.microsoft.com/es-es/help/4027947/microsoft-edge-delete-cookies" className="text-green-600 hover:underline" target="_blank" rel="noopener">Edge</a></li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">Actualización de la política</h2>
        <p>
          Esta política de cookies puede ser actualizada periódicamente. La fecha de la última actualización 
          se indica en la parte superior del documento.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">Contacto</h2>
        <p>
          Para cualquier consulta sobre nuestra política de cookies, puede contactarnos en <strong>{businessData.email}</strong>.
        </p>
      </section>
    </div>
  </div>
);